export default __webpack_public_path__ + "static/media/play-icon.2842a988.svg";